import { apiClient, API_PRX } from '@indipia/shared';

const BASE = API_PRX.MEMBER;

// ── 타입 ──────────────────────────────────────────────────────────────────────

export interface PrivacySettings {
  termsYn: 'Y' | 'N';
  marketingYn: 'Y' | 'N';
  nightMarketingYn: 'Y' | 'N';
  marketingPushYn: 'Y' | 'N';
  marketingSmsYn: 'Y' | 'N';
  marketingKakaoYn: 'Y' | 'N';
  marketingEmailYn: 'Y' | 'N';
}

export type PrivacySettingsPatch = Partial<
  Pick<
    PrivacySettings,
    'marketingYn' | 'nightMarketingYn' | 'marketingPushYn' | 'marketingSmsYn' | 'marketingKakaoYn' | 'marketingEmailYn'
  >
>;

// ── 수신동의 조회 ─────────────────────────────────────────────────────────────

export async function fetchPrivacySettings(): Promise<PrivacySettings> {
  const res = await apiClient.get(`${BASE}/users/privacy-settings`);
  return res.data.data as PrivacySettings;
}

// ── 수신동의 수정 ─────────────────────────────────────────────────────────────

export async function updatePrivacySettings(patch: PrivacySettingsPatch): Promise<void> {
  await apiClient.patch(`${BASE}/users/privacy-settings`, patch);
}
